import { CATEGORY_CODES } from '_constants/categories';
import { FIELD_KEYS } from '_constants/forms';
import { PRODUCT_CODES } from '_constants/products';

const productCodeMap = {
  [CATEGORY_CODES.accounting]: PRODUCT_CODES.accountingTaxAmendment,
  [CATEGORY_CODES.ein]: PRODUCT_CODES.einTaxAmendment,
  [CATEGORY_CODES.inc]: PRODUCT_CODES.incTaxAmendment,
  [CATEGORY_CODES.incStates]: PRODUCT_CODES.incStatesTaxAmendment,
};

export const createBody = ({ category, form = {} }) => {
  const products = [];
  const code = productCodeMap[category];

  if (code) {
    products.push({
      code,
      fileId: form[FIELD_KEYS.returnToAmend] || null,
      reason: form[FIELD_KEYS.reasonForAmendment] || null,
    });
  }

  return {
    order: {
      processingOption: 'UPSELL',
    },
    products,
  };
};
